import Plan, { UserPlan } from '~/types/Plan';
import { ActionKeys } from './constants';

export function fetchUserPlans() {
  return <const>{
    type: ActionKeys.FETCH_USER_PLANS,
  };
}

export function fetchUserPlansSuccess(userPlans: UserPlan[]) {
  return <const>{
    type: ActionKeys.FETCH_USER_PLANS_SUCCESS,
    payload: {
      userPlans,
    },
  };
}

export function fetchUserPlansError(errorMessage: string) {
  return <const>{
    type: ActionKeys.FETCH_USER_PLANS_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export function fetchPricingPlans() {
  return <const>{
    type: ActionKeys.FETCH_PRICING_PLANS,
  };
}

export function fetchPricingPlansSuccess(pricingPlans: Plan[]) {
  return <const>{
    type: ActionKeys.FETCH_PRICING_PLANS_SUCCESS,
    payload: {
      pricingPlans,
    },
  };
}

export function fetchPricingPlansError(errorMessage: string) {
  return <const>{
    type: ActionKeys.FETCH_PRICING_PLANS_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export type PlanUpdateEntryPoints =
  | 'carrier-accounts'
  | 'adjust-plan'
  | 'adjust-plan-downgrade'
  | 'BYOA'
  | 'store_connection'
  | 'monthly_label_limit';

/**
 * Update the user plan
 * @param planName display name of plan to update to
 * @param entryPoint entry point for the plan change, used for tracking
 */
export function updateUserPlan(planName: string, entryPoint?: PlanUpdateEntryPoints) {
  return <const>{
    type: ActionKeys.UPDATE_USER_PLAN,
    payload: { planName, entryPoint: entryPoint ?? undefined },
  };
}

export function updateUserPlanSuccess(userPlan: UserPlan) {
  return <const>{
    type: ActionKeys.UPDATE_USER_PLAN_SUCCESS,
    payload: {
      userPlan,
    },
  };
}

export function updateUserPlanError(errorMessage: string) {
  return <const>{
    type: ActionKeys.UPDATE_USER_PLAN_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export function resetSetPlanRequest() {
  return <const>{
    type: ActionKeys.RESET_USER_PLAN_REQUEST,
  };
}

export function closeWixProPlanNotification() {
  return <const>{
    type: ActionKeys.CLOSE_WIX_PRO_PLAN_NOTIFICATION,
  };
}

export function openCloseAccountModal() {
  return <const>{
    type: ActionKeys.OPEN_CLOSE_ACCOUNT_MODAL,
  };
}

export function dismissCloseAccountModal() {
  return <const>{
    type: ActionKeys.DISMISS_CLOSE_ACCOUNT_MODAL,
  };
}

export function submitCloseAccountForm(reason: string, tellUsMore = '') {
  return <const>{
    type: ActionKeys.SUBMIT_CLOSE_ACCOUNT_FORM,
    payload: {
      reason,
      tellUsMore,
    },
  };
}

export function closeAccountSuccess(closeStatus: string) {
  return <const>{
    type: ActionKeys.CLOSE_ACCOUNT_SUCCESS,
    payload: {
      closeStatus,
    },
  };
}

export function closeAccountError(errorMessage: string) {
  return <const>{
    type: ActionKeys.CLOSE_ACCOUNT_ERROR,
    payload: {
      errorMessage,
    },
  };
}

export function setAdjustedPlan(plan: Plan) {
  return <const>{
    type: ActionKeys.SET_ADJUSTED_PLAN,
    payload: {
      plan,
    },
  };
}

export type PlansActions =
  | ReturnType<typeof fetchUserPlans>
  | ReturnType<typeof fetchUserPlansSuccess>
  | ReturnType<typeof fetchUserPlansError>
  | ReturnType<typeof fetchPricingPlans>
  | ReturnType<typeof fetchPricingPlansSuccess>
  | ReturnType<typeof fetchPricingPlansError>
  | ReturnType<typeof updateUserPlan>
  | ReturnType<typeof updateUserPlanSuccess>
  | ReturnType<typeof updateUserPlanError>
  | ReturnType<typeof resetSetPlanRequest>
  | ReturnType<typeof closeWixProPlanNotification>
  | ReturnType<typeof openCloseAccountModal>
  | ReturnType<typeof dismissCloseAccountModal>
  | ReturnType<typeof submitCloseAccountForm>
  | ReturnType<typeof closeAccountSuccess>
  | ReturnType<typeof closeAccountError>
  | ReturnType<typeof setAdjustedPlan>;
